import { Card, ThemeProvider } from "@mui/material";
import LoadingScreen from "components/loading/LoadingScreen";
import Table from "components/table/Table";
import { ALL_OPTION } from "constant";
import moment from "moment";
import { useMemo, useState } from "react";
import {
  useExportReportInboundPerformance,
  useGetReportInboundPerformance,
} from "service/query/report.query";
import muiTheme from "theme/muiTheme";

import ReportInboundPerformanceFilter from "./components/ReportInboundPerformanceFilter";

const ReportInboundPerformance = () => {
  const [filter, setFilter] = useState(null);

  const cskhColumns = useMemo(
    () => [
      {
        id: "date",
        name: "Ngày",
        type: "dateDMY",
        width: "120px",
      },
      {
        id: "contactCenter",
        name: "Contact center",
      },
      {
        id: "agentCode",
        name: "Mã nhân viên",
      },
      {
        id: "agentName",
        name: "Tên nhân viên",
      },
      {
        id: "totalOnlineTime",
        name: "Thời gian trực tuyến",
        type: "timeMilliseconds",
        align: "center",
      },
      {
        id: "totalReadyTime",
        name: "Thời gian sẵn sàng",
        type: "timeMilliseconds",
        align: "center",
      },
      {
        id: "totalRespiteTime",
        name: "Thời gian tạm nghỉ",
        type: "timeMilliseconds",
        align: "center",
      },
      {
        id: "totalAnswerDuration",
        name: "Thời gian nói chuyện",
        type: "timeSeconds",
        align: "center",
      },
      {
        id: "averageAnswerDuration",
        name: "Thời gian thoại trung bình",
        type: "timeSeconds",
        align: "center",
      },
      {
        id: "totalCall",
        name: "Tổng cuộc gọi",
        align: "center",
        type: "number",
      },
      {
        id: "totalAnsweredCall",
        name: "Trả lời",
        align: "center",
        type: "number",
      },
      {
        id: "totalMissedCall",
        name: "Nhỡ",
        align: "center",
        type: "number",
      },
      {
        id: "totalRejectedCall",
        name: "Từ chối",
        align: "center",
        type: "number",
      },
    ],
    []
  );

  const postofficeColumns = useMemo(
    () => [
      {
        id: "date",
        name: "Ngày",
        type: "dateDMY",
        width: "120px",
      },
      {
        id: "cityname",
        name: "BĐT/TP",
      },
      {
        id: "nameProvince",
        name: "Bưu cục",
      },
      {
        id: "extensionName",
        name: "Máy lẻ",
      },
      {
        id: "totalAnswerDuration",
        name: "Thời gian nói chuyện",
        type: "timeSeconds",
        align: "center",
      },
      {
        id: "averageAnswerDuration",
        name: "Thời gian thoại trung bình",
        type: "timeSeconds",
        align: "center",
      },
      {
        id: "totalCall",
        name: "Tổng cuộc gọi",
        align: "center",
        type: "number",
      },
      {
        id: "totalAnsweredCall",
        name: "Trả lời",
        align: "center",
        type: "number",
      },
      {
        id: "totalBusyCall",
        name: "Bận",
        align: "center",
        type: "number",
      },
      {
        id: "totalNoAnsweredCall",
        name: "Không trả lời",
        align: "center",
        type: "number",
      },
      {
        id: "totalTransferCall",
        name: "Chuyển tiếp đi",
        align: "center",
        type: "number",
      },
    ],
    []
  );

  const handleSubmit = (values) => {
    setFilter({
      fromDate: moment(values.dateRange[0]).startOf("day").toISOString(),
      toDate: moment(values.dateRange[1]).endOf("day").toISOString(),
      code: values.code.includes(ALL_OPTION.value) ? [] : values.code,
      exportFile: false,
      toNumber: values.phoneNumber.includes(ALL_OPTION.value)
        ? []
        : values.phoneNumber,
      typeProvince: values.typeProvince,
    });
  };

  const { data: reportInboundPerformanceData, isFetching } =
    useGetReportInboundPerformance(filter, {
      enabled: !!filter,
    });

  const {
    refetch: exportReportInboundPerformance,
    isFetching: isFetchingExport,
  } = useExportReportInboundPerformance(
    {
      ...filter,
      exportFile: true,
    },
    { enabled: false }
  );

  const handleExport = () => {
    exportReportInboundPerformance();
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <Card sx={{ p: 2 }}>
        <ReportInboundPerformanceFilter
          onSubmit={handleSubmit}
          onExport={handleExport}
          disabledExport={!filter}
        />
      </Card>

      {filter && (
        <Card sx={{ mt: 2, overflow: "auto" }}>
          <Table
            columns={
              filter.typeProvince === "postoffice"
                ? postofficeColumns
                : cskhColumns
            }
            data={reportInboundPerformanceData}
            showBorder
          />
        </Card>
      )}

      <LoadingScreen loading={isFetching || isFetchingExport} />
    </ThemeProvider>
  );
};

export default ReportInboundPerformance;
